var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskAversionGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410.792,
    height: 278.981,
    viewBox: "0 0 410.792 278.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .risk-cls-1 {\n        fill: #edf1fe;\n      }\n\n      .risk-cls-2, .risk-cls-3, .risk-cls-4, .risk-cls-7 {\n        fill: #262626;\n      }\n\n      .risk-cls-2 {\n        font-size: 10px;\n      }\n\n      .risk-cls-2, .risk-cls-3, .risk-cls-4 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .risk-cls-3 {\n        font-size: 11px;\n      }\n\n      .risk-cls-4 {\n        font-size: 8px;\n      }\n\n      .risk-cls-5 {\n        fill: #bbd7e2;\n      }\n\n      .risk-cls-6 {\n        fill: #fff;\n      }\n\n      .risk-cls-8 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    name: "Group 3905",
    transform: "translate(-514.354 -845.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    name: "Group 3842",
    transform: "translate(514.354 845.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    name: "Group 3840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    name: "Group 3839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    name: "Group 3903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    name: "Path 5605",
    className: "risk-cls-1",
    d: "M205.4,0c113.437,0,205.4,91.959,205.4,205.4-.232-.263-410.514-.278-410.792,0C0,91.959,91.959,0,205.4,0",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "H",
    className: "risk-cls-2",
    transform: "translate(19.971 189.209) rotate(-83.543)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "I",
    className: "risk-cls-2",
    transform: "translate(21.199 178.984) rotate(-81.277)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "G",
    className: "risk-cls-3",
    transform: "translate(22.842 174.622) rotate(-79.065)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G")), /*#__PURE__*/React.createElement("text", {
    id: "H-2",
    name: "H",
    className: "risk-cls-2",
    transform: "translate(23.743 164.755) rotate(-75.963)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    name: " ",
    className: "risk-cls-4",
    transform: "translate(24.387 154.241) rotate(-73.749)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "C",
    className: "risk-cls-2",
    transform: "translate(27.413 150.879) rotate(-71.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    className: "risk-cls-3",
    transform: "matrix(0.365, -0.931, 0.931, 0.365, 31.244, 142.484)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    className: "risk-cls-2",
    transform: "matrix(0.422, -0.907, 0.907, 0.422, 34.224, 132.147)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "F",
    className: "risk-cls-2",
    transform: "translate(39.366 121.256) rotate(-61.914)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    name: "O",
    className: "risk-cls-3",
    transform: "translate(44.071 114.529) rotate(-59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "R",
    className: "risk-cls-2",
    transform: "matrix(0.561, -0.828, 0.828, 0.561, 48.764, 104.846)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "T",
    className: "risk-cls-2",
    transform: "translate(54.02 97.14) rotate(-53.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    name: " ",
    className: "risk-cls-4",
    transform: "translate(57.3 89.486) rotate(-51.372)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "W",
    className: "risk-cls-3",
    transform: "matrix(0.662, -0.749, 0.749, 0.662, 62.063, 88.146)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "I-2",
    name: "I",
    className: "risk-cls-2",
    transform: "translate(70.898 76.852) rotate(-45.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "T-2",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(74.099 73.552) rotate(-43.715)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "H-3",
    name: "H",
    className: "risk-cls-2",
    transform: "matrix(0.756, -0.655, 0.655, 0.756, 79.909, 67.983)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    name: " ",
    className: "risk-cls-4",
    transform: "matrix(0.78, -0.625, 0.625, 0.78, 86.491, 59.733)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "V",
    className: "risk-cls-3",
    transform: "translate(91.48 59.532) rotate(-36.626)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("text", {
    id: "O-3",
    name: "O",
    className: "risk-cls-3",
    transform: "matrix(0.833, -0.553, 0.553, 0.833, 98.896, 54.012)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "L",
    className: "risk-cls-2",
    transform: "translate(107.3 47.292) rotate(-30.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "A",
    className: "risk-cls-2",
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 114.11, 43.233)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "T-3",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(122.388 38.857) rotate(-25.408)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "I-3",
    name: "I",
    className: "risk-cls-2",
    transform: "translate(129.672 35.444) rotate(-23.458)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "L-2",
    name: "L",
    className: "risk-cls-2",
    transform: "translate(133.88 33.601) rotate(-21.533)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "I-4",
    name: "I",
    className: "risk-cls-2",
    transform: "matrix(0.942, -0.335, 0.335, 0.942, 141.227, 30.745)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "T-4",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(145.566 29.182) rotate(-17.641)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "Y",
    className: "risk-cls-2",
    transform: "translate(153.071 26.798) rotate(-15.093)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "L-3",
    name: "L",
    className: "risk-cls-2",
    transform: "matrix(0.967, 0.255, -0.255, 0.967, 249.359, 24.488)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "O-4",
    name: "O",
    className: "risk-cls-3",
    transform: "translate(256.547 27.391) rotate(17.586)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "W-2",
    name: "W",
    className: "risk-cls-3",
    transform: "translate(266.473 30.484) rotate(21.408)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    name: " ",
    className: "risk-cls-4",
    transform: "matrix(0.912, 0.411, -0.411, 0.912, 281.096, 33.157)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "C-2",
    name: "C",
    className: "risk-cls-2",
    transform: "translate(284 36.621) rotate(26.348)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "O-5",
    name: "O",
    className: "risk-cls-3",
    transform: "translate(291.774 41.582) rotate(29.386)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "M-2",
    name: "M",
    className: "risk-cls-2",
    transform: "matrix(0.84, 0.543, -0.543, 0.84, 301.622, 45.983)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "F-2",
    name: "F",
    className: "risk-cls-2",
    transform: "translate(311.69 52.576) rotate(35.996)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    id: "O-6",
    name: "O",
    className: "risk-cls-3",
    transform: "translate(317.71 58.163) rotate(38.879)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "R-2",
    name: "R",
    className: "risk-cls-2",
    transform: "translate(326.652 64.136) rotate(41.958)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "T-5",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(333.543 70.371) rotate(44.591)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    name: " ",
    className: "risk-cls-4",
    transform: "translate(340.703 74.685) rotate(46.452)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "W-3",
    name: "W",
    className: "risk-cls-3",
    transform: "translate(341.374 79.58) rotate(49.297)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "I-5",
    name: "I",
    className: "risk-cls-2",
    transform: "matrix(0.613, 0.79, -0.79, 0.613, 351.363, 89.869)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "T-6",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(354.201 93.497) rotate(54.122)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "H-4",
    name: "H",
    className: "risk-cls-2",
    transform: "matrix(0.545, 0.838, -0.838, 0.545, 358.925, 100.008)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    name: " ",
    className: "risk-cls-4",
    transform: "translate(366.188 107.642) rotate(59.164)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "V-2",
    name: "V",
    className: "risk-cls-3",
    transform: "translate(365.712 112.624) rotate(61.273)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("text", {
    id: "O-7",
    name: "O",
    className: "risk-cls-3",
    transform: "translate(370.158 120.724) rotate(64.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "L-4",
    name: "L",
    className: "risk-cls-2",
    transform: "matrix(0.387, 0.922, -0.922, 0.387, 375.648, 129.962)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "A-2",
    name: "A",
    className: "risk-cls-2",
    transform: "matrix(0.343, 0.94, -0.94, 0.343, 378.722, 137.265)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "T-7",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(381.91 146.09) rotate(72.606)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "I-6",
    name: "I",
    className: "risk-cls-2",
    transform: "matrix(0.266, 0.964, -0.964, 0.266, 384.276, 153.779)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "L-5",
    name: "L",
    className: "risk-cls-2",
    transform: "translate(385.518 158.219) rotate(76.493)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "I-7",
    name: "I",
    className: "risk-cls-2",
    transform: "translate(387.316 165.877) rotate(78.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "T-8",
    name: "T",
    className: "risk-cls-2",
    transform: "translate(388.258 170.382) rotate(80.349)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "Y-2",
    name: "Y",
    className: "risk-cls-2",
    transform: "matrix(0.124, 0.992, -0.992, 0.124, 389.575, 178.155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    name: "Group 3843",
    transform: "translate(544.021 876.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    name: "Path 5595",
    className: "risk-cls-5",
    d: "M164.772,175.073,252.464,23.187a175.256,175.256,0,0,0-175.1.5Z",
    transform: "translate(9.738 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595_-_Outline",
    name: "Path 5595 - Outline",
    className: "risk-cls-6",
    d: "M164.772,178.073,75.32,23.139l1.291-.752a176.451,176.451,0,0,1,176.6-.5l1.3.749ZM79.415,24.233l85.357,147.841L250.41,23.744a173.449,173.449,0,0,0-170.995.488Z",
    transform: "translate(9.738 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    name: "Path 5596",
    className: "risk-cls-5",
    d: "M330.636,172.465A174.6,174.6,0,0,0,243.3,20.492L155,172.465Z",
    transform: "translate(19.51 3.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596_-_Outline",
    name: "Path 5596 - Outline",
    className: "risk-cls-6",
    d: "M332.136,173.965H152.394L242.757,18.448l1.294.744a175.693,175.693,0,0,1,81.777,105.972,179.426,179.426,0,0,1,6.308,47.3Zm-174.53-3H329.13a176.312,176.312,0,0,0-6.2-45.011A172.547,172.547,0,0,0,243.847,22.542Z",
    transform: "translate(19.51 3.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    name: "Path 5597",
    className: "risk-cls-5",
    d: "M87.1,21.035A174.991,174.991,0,0,0,0,172.426H174.51Z",
    transform: "translate(0 2.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597_-_Outline",
    name: "Path 5597 - Outline",
    className: "risk-cls-6",
    d: "M87.651,18.981l89.458,154.945H-1.5v-1.5A176.779,176.779,0,0,1,86.349,19.739Zm84.262,151.945L86.561,23.095A173.237,173.237,0,0,0,1.506,170.926Z",
    transform: "translate(0 2.648)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "risk-cls-6",
    cx: 73.175,
    cy: 73.175,
    r: 73.175,
    transform: "translate(645.791 978.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    name: "Path 5641",
    className: "risk-cls-7",
    d: "M-18.288,0V-11.2h2.144l4.768,7.9h-1.136l4.688-7.9H-5.7L-5.664,0H-8.1l-.016-7.472h.448l-3.744,6.288h-1.168L-16.4-7.472h.544V0ZM-.624-6.688H4.768v2.016H-.624ZM-.432-2.08h6.1V0H-3.008V-11.2H5.456v2.08H-.432ZM7.728,0V-11.2h5.088a7.1,7.1,0,0,1,3.216.7A5.313,5.313,0,0,1,18.208-8.56a5.449,5.449,0,0,1,.784,2.96,5.459,5.459,0,0,1-.784,2.952A5.294,5.294,0,0,1,16.032-.7a7.1,7.1,0,0,1-3.216.7ZM10.32-2.128h2.368a4.2,4.2,0,0,0,1.944-.424,3.075,3.075,0,0,0,1.28-1.208,3.6,3.6,0,0,0,.456-1.84,3.584,3.584,0,0,0-.456-1.848,3.09,3.09,0,0,0-1.28-1.2,4.2,4.2,0,0,0-1.944-.424H10.32Z",
    transform: "translate(718.4 933.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    name: "Path 5640",
    className: "risk-cls-7",
    d: "M-19.28,0V-11.2h2.592v9.088h5.616V0ZM-4.368.192A6.811,6.811,0,0,1-6.824-.24,5.811,5.811,0,0,1-8.776-1.456a5.549,5.549,0,0,1-1.28-1.84,5.75,5.75,0,0,1-.456-2.3,5.75,5.75,0,0,1,.456-2.3,5.494,5.494,0,0,1,1.288-1.84A5.918,5.918,0,0,1-6.816-10.96a6.7,6.7,0,0,1,2.432-.432,6.683,6.683,0,0,1,2.44.432A5.847,5.847,0,0,1-.008-9.744,5.674,5.674,0,0,1,1.28-7.912,5.648,5.648,0,0,1,1.744-5.6,5.72,5.72,0,0,1,1.28-3.288,5.54,5.54,0,0,1-.008-1.448,5.915,5.915,0,0,1-1.944-.24,6.638,6.638,0,0,1-4.368.192Zm-.016-2.208A3.653,3.653,0,0,0-3-2.272a3.319,3.319,0,0,0,1.112-.736,3.361,3.361,0,0,0,.744-1.136A3.867,3.867,0,0,0-.88-5.6a3.867,3.867,0,0,0-.264-1.456A3.423,3.423,0,0,0-1.88-8.192a3.216,3.216,0,0,0-1.112-.736,3.714,3.714,0,0,0-1.392-.256,3.653,3.653,0,0,0-1.384.256,3.319,3.319,0,0,0-1.112.736,3.361,3.361,0,0,0-.744,1.136A3.867,3.867,0,0,0-7.888-5.6a3.884,3.884,0,0,0,.264,1.448,3.4,3.4,0,0,0,.736,1.144,3.216,3.216,0,0,0,1.112.736A3.714,3.714,0,0,0-4.384-2.016ZM6.016,0,2.352-11.2H5.04L8.224-1.28H6.88l3.328-9.92h2.4l3.2,9.92h-1.3l3.264-9.92h2.48L16.592,0H13.808L10.976-8.7h.736L8.8,0Z",
    transform: "translate(611.312 983.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    name: "Path 5642",
    className: "risk-cls-7",
    d: "M-12.712-11.2h2.592V0h-2.592ZM-17.8,0h-2.592V-11.2H-17.8Zm5.28-4.592h-5.472V-6.784h5.472ZM-7.464,0V-11.2h2.592V0ZM3.192.192A6.8,6.8,0,0,1,.752-.232,5.743,5.743,0,0,1-1.184-1.44a5.549,5.549,0,0,1-1.28-1.84A5.791,5.791,0,0,1-2.92-5.6a5.791,5.791,0,0,1,.456-2.32A5.494,5.494,0,0,1-1.176-9.76,5.813,5.813,0,0,1,.776-10.968a6.908,6.908,0,0,1,2.464-.424,6.917,6.917,0,0,1,2.68.5,5.307,5.307,0,0,1,2.008,1.44L6.264-7.92a4.061,4.061,0,0,0-1.328-.952,3.9,3.9,0,0,0-1.568-.312,4.15,4.15,0,0,0-1.488.256,3.315,3.315,0,0,0-1.16.736A3.3,3.3,0,0,0-.032-7.056,3.867,3.867,0,0,0-.3-5.6,3.823,3.823,0,0,0-.032-4.16,3.388,3.388,0,0,0,.72-3.016a3.274,3.274,0,0,0,1.152.744,4.038,4.038,0,0,0,1.464.256,4.608,4.608,0,0,0,1.5-.248A4.317,4.317,0,0,0,6.248-3.1L7.72-1.232A6.751,6.751,0,0,1,5.6-.176,8.227,8.227,0,0,1,3.192.192Zm2.16-1.76V-5.776H7.72v4.544ZM17.8-11.2h2.592V0H17.8ZM12.712,0H10.12V-11.2h2.592Zm5.28-4.592H12.52V-6.784h5.472Z",
    transform: "translate(824.663 983.877)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2730",
    name: "Rectangle 2730",
    className: "risk-cls-8",
    width: 169.048,
    height: 116.534,
    transform: "translate(634.963 947.531)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAversionGauge);
export default __webpack_public_path__ + "static/media/RiskAversionGauge.ba68fba3179ee5dce8f2efcb8ba20dd9.svg";
export { ForwardRef as ReactComponent };